import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dropdown } from "primereact/dropdown";
import { Panel } from "primereact/panel";
import { Slider } from "primereact/slider";

import "../../styles/availableTitles.css";
import { Checkbox } from "primereact/checkbox";
import * as XLSX from "xlsx";

const SearchTitles = () => {
  const [loading, setLoading] = useState(false);
  const [titles, setTitles] = useState(null);
  const [platformDialog, setPlatformDialog] = useState(false);
  const [platform, setPlatform] = useState({});
  const [pageSize, setPageSize] = useState(5);
  const [hasVendorID, setHasVendorID] = useState(true);
  const [licensedBySOFA, setLicensedBySOFA] = useState(false);
  const [availableGlobally, setAvailableGlobally] = useState(false);
  const [minRating, setMinRating] = useState(0);
  const [minVoteCount, setMinVoteCount] = useState(0);
  const [minNetflixWatchedHours, setMinNetflixWatchedHours] = useState("");
  const [maxRating, setMaxRating] = useState(9.5);
  const [titleFilter, setTitleFilter] = useState("");
  const [genreFilter, setGenreFilter] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [totalTitles, setTotalTitles] = useState([]);
  const [pageViews, setPageViews] = useState(0);
  const [outputsForPlatform, setOutputsForPlatform] = useState(0);
  const [conversionPercentage, setConversionPercentage] = useState(0);
  const [minPageViews, setMinPageViews] = useState(0);
  const [maxPageViews, setMaxPageViews] = useState(1000);
  const [minStreams, setMinStreams] = useState(0);
  const [minStreamedHours, setMinStreamedHours] = useState(0);
  const [minUniqueViewers, setMinUniqueViewers] = useState(0);
  const [isDirectorChecked, setIsDirectorChecked] = useState(false);
  const [isActorChecked, setIsActorChecked] = useState(false);
  const [professionalFilter, setProfessionalFilter] = useState("");

  const loadTitles = async () => {
    const url = process.env.REACT_APP_URL_FILTER_ALL_TITLE;

    const payload = {
      title: titleFilter,
      genre: genreFilter,
      imdbMinRating: minRating,
      imdbMaxRating: maxRating,
      imdbMinVoteCount: minVoteCount,
      hasVendorID: hasVendorID,
      minNetflixJWatchedHours: minNetflixWatchedHours,
      country: countryFilter,
      netflixLicensedBySOFA: licensedBySOFA,
      netflixAvailableGlobally: availableGlobally,
      minPageViews: minPageViews,
      maxPageViews: maxPageViews,
      minOutputsForPlatform: outputsForPlatform,
      minConversionPercentage: conversionPercentage,
      minStreams: minStreams,
      minStreamedHours: minStreamedHours,
      minUniqueViewers: minUniqueViewers,
      professional: professionalFilter,
      isDirectorChecked: isDirectorChecked,
      isActorChecked: isActorChecked,
    };

    if (professionalFilter !== "" && !isDirectorChecked && !isActorChecked) {
      alert("Please select at least one checkbox for professional filter");
      setLoading(false);
      return
    }

    if ( titleFilter === "" && 
      genreFilter === "" && 
      minRating === 0 && 
      maxRating === 9.5 && 
      minVoteCount === 0 && 
      hasVendorID === true && 
      minNetflixWatchedHours === "" && 
      countryFilter === "" && 
      licensedBySOFA === false && 
      availableGlobally === false && 
      minPageViews === 0 && 
      maxPageViews === 1000 && 
      outputsForPlatform === 0 && 
      conversionPercentage === 0 && 
      minStreams === 0 && 
      minStreamedHours === 0 && 
      minUniqueViewers === 0 && 
      (
      professionalFilter === "" && !isDirectorChecked && !isActorChecked )) { 
        alert("Please select at least one filter"); 
        setLoading(false); 
        return; 
      }


    console.log(payload);
    axios.post(url, payload).then((res) => {
      const result = res.data.map((item) => {
      const vendorId = item.vendor_id;
      const formattedVendorId = vendorId.replace(/(.{10})/g, '$1\n');
      return {
        ...item,
        vendor_id: formattedVendorId,
        imdb_code: item.imdb_code.includes("tt") ? item.imdb_code : "",
      };
      });
      setTitles(result);
      setTotalTitles(result.length);
      setLoading(false);
    });
  };

  function formatNumber(value) {
    // Verifica se o valor é um número e formata com separadores de milhar
    return value ? value.toLocaleString() : "";
  }

  const hideDialog = () => {
    setPlatformDialog(false);
  };

  const loadPlatformTemplates = async () => {
    const url = process.env.REACT_APP_URL_PLATFORM_TEMPLATE_TITLE;
    axios.get(url).then((res) => {
      const data = res.data.map((item) => {
        return {
          name: item.name,
          code: item.id,
          id: item.id,
          availsType: item.availsType,
        };
      });
    });
  };

  useEffect(() => {
    //loadPlatformTemplates();
  }, []);

  const handleSearch = async () => {
    setSelectedTitles([]);
    setLoading(true);
    loadTitles();
  };

  const handleClearFilters = () => {
    setTitleFilter("");
    setGenreFilter("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const options = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
    { label: "All", value: "all" },
  ];

  const onDropdownChange = (e) => {
    setHasVendorID(e.value);
  };

  const onDropdownChangeLicensedBySOFA = (e) => {
    setLicensedBySOFA(e.value);
  };

  const onDropdownChangeAvailableGlobally = (e) => {
    setAvailableGlobally(e.value);
  };

  function formatRuntime(runtime) {
    return runtime.slice(3);
  }

  const exportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(titles);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "export.xlsx");
  };

  return (
    <div>
      <div className="col-12">
        <div className="card">
          <div className="panel-container">
          <Panel header="Metadata">
            <div className="field">
              <label htmlFor="title">Title</label>
              <br />
              <InputText
                id="titleFilter"
                onChange={(e) => setTitleFilter(e.target.value)}
                value={titleFilter}
                onKeyDown={(e) => handleKeyDown(e)}
                className="metadata-input"
              />
            </div>
            <div className="inline-fields">
              <div className="field">
                <label htmlFor="Genre">Genre</label>
                <br />
                <InputText
                  id="genre"
                  onChange={(e) => setGenreFilter(e.target.value)}
                  value={genreFilter}
                  onKeyDown={(e) => handleKeyDown(e)}
                  className="metadata-input-small"
                />
              </div>
              <div className="field">
                <label htmlFor="Country">Prod.Country</label>
                <br />
                <InputText
                  id="country"
                  onChange={(e) => setCountryFilter(e.target.value)}
                  value={countryFilter}
                  onKeyDown={(e) => handleKeyDown(e)}
                  className="metadata-input-small"
                />
              </div>
            </div>

            {/* New Field for Professional */}
            <div className="field">
              <label htmlFor="professional">Professional</label>
              <br />
              <InputText
                id="professional"
                onChange={(e) => setProfessionalFilter(e.target.value)}
                value={professionalFilter}
                onKeyDown={(e) => handleKeyDown(e)}
                className="metadata-input"
              />
              <div className="field flex">
              <div className="checkbox-group"> {/* Added a group for better styling */}
                  <label htmlFor="directorCheckbox"> Director</label>
                  <Checkbox
                    inputId="directorCheckbox"
                    checked={isDirectorChecked}
                    onChange={(e) => setIsDirectorChecked(e.checked)}
                  />
                
                </div>
                &nbsp;&nbsp;
              <div className="checkbox-group" style={{ marginRight: '20px' }}>
                  <label htmlFor="actorCheckbox"> Actor</label>
                  <Checkbox
                    inputId="actorCheckbox"
                    checked={isActorChecked}
                    onChange={(e) => setIsActorChecked(e.checked)}
                  />
                
              </div>
            </div>

            {/* Checkboxes for Director and Actor */}
            
            </div>
          </Panel>
            <Panel header="Netflix">
              <div className="field" style={{ width: 200 }}>
                <label htmlFor="netflixjanjun2023">
                  Min Watched Hours: {minNetflixWatchedHours.toLocaleString()}
                </label>
                <Slider
                  id="netflixjanjun2023"
                  value={minNetflixWatchedHours}
                  onChange={(e) => setMinNetflixWatchedHours(e.value)}
                  min={0}
                  max={10000000}
                  step={100000}
                  style={{ width: "150px" }}
                />
              </div>
              <div className="field">
                <label htmlFor="Genre">Licensed by SOFA?</label>
                <br />
                <Dropdown
                  value={licensedBySOFA}
                  options={options}
                  onChange={onDropdownChangeLicensedBySOFA}
                  placeholder="Select an option"
                />
              </div>
              <div className="field">
                <label htmlFor="Genre">Available Globally?</label>
                <br />
                <Dropdown
                  value={availableGlobally}
                  options={options}
                  onChange={onDropdownChangeAvailableGlobally}
                  placeholder="Select an option"
                />
              </div>
            </Panel>
            <Panel header="IMDB">
              <div className="field" style={{ width: 200 }}>
                <label htmlFor="votecount">
                  Min Vote Count: {minVoteCount}
                </label>
                <Slider
                  id="votecount"
                  value={minVoteCount}
                  onChange={(e) => setMinVoteCount(e.value)}
                  min={0}
                  max={10000}
                  step={100}
                  style={{ width: "150px" }}
                />
              </div>
              <div className="field">
                <label htmlFor="Genre">Min Rating: {minRating}</label>
                <Slider
                  id="minRating"
                  value={minRating}
                  onChange={(e) => setMinRating(e.value)}
                  min={0}
                  max={10}
                  step={0.5}
                  style={{ width: "150px" }}
                />
              </div>
              <div className="field">
                <label htmlFor="Genre">Max Rating: {maxRating}</label>
                <Slider
                  id="maxRating"
                  value={maxRating}
                  onChange={(e) => setMaxRating(e.value)}
                  min={1}
                  max={10}
                  step={0.5}
                  style={{ width: "150px" }}
                />
              </div>
            </Panel>
            <Panel header="Filmelier Last Week">
              <div className="field">
                <label htmlFor="minPageViews">
                  Min Pg. Views: {minPageViews}
                </label>
                <Slider
                  id="minPageViews"
                  value={minPageViews}
                  onChange={(e) => setMinPageViews(e.value)}
                  step={10}
                  min={0}
                  max={1000}
                  style={{ width: "150px" }}
                  className="custom-slider"
                />
              </div>
              <div className="field">
                <label htmlFor="maxPageViews">
                  Max Pg. Views: {maxPageViews}
                </label>
                <Slider
                  id="maxPageViews"
                  value={maxPageViews}
                  onChange={(e) => setMaxPageViews(e.value)}
                  step={10}
                  min={0}
                  max={1000}
                  style={{ width: "150px" }}
                  className="custom-slider"
                />
              </div>
              <div className="field" style={{ width: 200 }}>
                <label htmlFor="outputsForPlatform">
                  Min Platform Outputs: {outputsForPlatform}
                </label>
                <Slider
                  id="outputsForPlatform"
                  value={outputsForPlatform}
                  onChange={(e) => setOutputsForPlatform(e.value)}
                  min={0}
                  max={800}
                  step={20}
                  style={{ width: "150px" }}
                  className="custom-slider"
                />
              </div>
              <div className="field" style={{ width: 200 }}>
                <label htmlFor="conversionPercentage">
                  Min Conversion Percentage: {conversionPercentage}
                </label>
                <Slider
                  id="conversionPercentage"
                  value={conversionPercentage}
                  onChange={(e) => setConversionPercentage(e.value)}
                  step={0.05}
                  min={0}
                  max={1}
                  style={{ width: "150px" }}
                  className="custom-slider"
                />
              </div>
            </Panel>
            <Panel header="AdrenalinaPura Last Week">
              <div className="field">
                <label htmlFor="minStreams">Min. Streams: {minStreams}</label>
                <Slider
                  id="minStreams"
                  value={minStreams}
                  onChange={(e) => setMinStreams(e.value)}
                  step={10}
                  min={0}
                  max={1000}
                  style={{ width: "150px" }}
                  className="custom-slider-adrenalina"
                />
              </div>
              <div className="field">
                <label htmlFor="minStreamedHours">
                  Min. Streamed Hours: {minStreamedHours}
                </label>
                <Slider
                  id="minStreamedHours"
                  value={minStreamedHours}
                  onChange={(e) => setMinStreamedHours(e.value)}
                  step={10}
                  min={0}
                  max={1000}
                  style={{ width: "150px" }}
                  className="custom-slider-adrenalina"
                />
              </div>
              <div className="field">
                <label htmlFor="minUniqueViewers">
                  Min. Unique Viewers: {minUniqueViewers}
                </label>
                <Slider
                  id="minUniqueViewers"
                  value={minUniqueViewers}
                  onChange={(e) => setMinUniqueViewers(e.value)}
                  step={10}
                  min={0}
                  max={1000}
                  style={{ width: "150px" }}
                  className="custom-slider-adrenalina"
                />
              </div>
            </Panel>
            <div className="field">
            <label htmlFor="Genre">Has VendorID?</label>
            <br />
            <Dropdown
              value={hasVendorID}
              options={options}
              onChange={onDropdownChange}
              placeholder="Select an option"
            />
          </div>
          </div>

          

          <div className="field-group">
            <div className="buttonSearchField">
              <Button
                label="Search"
                icon="pi pi-search"
                className="p-button-success mr-2"
                onClick={() => handleSearch()}
              />
            </div>
          </div>

          {!loading ? (
            <>
              <span>Total:{totalTitles}</span>

              <DataTable
                paginator
                rows={pageSize}
                value={titles}
                removableSort
                scrollable
                scrollDirection="both"
                className="mt-3"
                selectionMode="checkbox"
                selection={selectedTitles}
                onSelectionChange={(e) => setSelectedTitles(e.value)}
              >
                <Column
                  sortable
                  field="vendor_id"
                  header="vendor_id"
                  style={{ width: "150px" }}
                  bodyStyle={{ fontSize: "9pt" }}
                ></Column>
                <Column
                  sortable
                  field="international_title"
                  header="international title"
                  style={{ width: "100px" }}
                ></Column>
                <Column
                  sortable
                  field="imdb_code"
                  header="imdb"
                  style={{ width: "100px" }}
                ></Column>
                <Column
                  sortable
                  field="production_year"
                  header="year"
                  style={{ width: "70px" }}
                ></Column>
                <Column
                  sortable
                  field="genres_list"
                  header="genres"
                  style={{ width: "150px" }}
                  bodyStyle={{ fontSize: "9pt" }}
                ></Column>
                <Column
                  sortable
                  field="production_country"
                  header="production country"
                  style={{ width: "70px" }}
                  bodyStyle={{ fontSize: "9pt" }}
                ></Column>
                <Column
                  sortable
                  field="runtime"
                  header="Runtime"
                  body={(rowData) => formatRuntime(rowData.runtime)}
                  style={{ width: "80px" }}
                ></Column>
                

                <Column
                  sortable
                  field="cast_list"
                  header="cast list"
                  style={{ width: "120px" }}
                  bodyStyle={{ fontSize: "9pt" }}
                ></Column>
                <Column
                  sortable
                  field="director_list"
                  header="director list"
                  style={{ width: "80px" }}
                  bodyStyle={{ fontSize: "9pt" }}
                ></Column>
                <Column
                  sortable
                  field="imdb_rating"
                  header="imdb rating"
                  style={{ width: "80px" }}
                ></Column>
                <Column
                  sortable
                  field="imdb_rating_count"
                  header="imdb rating count"
                  body={(rowData) => formatNumber(rowData.imdb_rating_count)}
                  style={{ width: "80px" }}
                ></Column>

                <Column
                  sortable
                  field="netflix_watched_hours"
                  header="Netflix Watched Hours"
                  body={(rowData) =>
                    formatNumber(rowData.netflix_watched_hours)
                  }
                  style={{ width: "80px" }}
                ></Column>
                <Column
                  sortable
                  field="netflix_sofa_licensed"
                  header="Netflix licensed by SOFA?"
                  style={{ width: "80px" }}
                ></Column>
                <Column
                  sortable
                  field="netflix_available_globally"
                  header="Netflix available globally?"
                  style={{ width: "80px" }}
                ></Column>
                <Column
                  sortable
                  field="filmelier_lastweek_pageviews"
                  header="Filmelier LW Page Views"
                  style={{ width: "80px" }}
                ></Column>
                <Column
                  sortable
                  field="filmelier_lastweek_outputplatforms"
                  header="Filmelier LW Output Platforms"
                  style={{ width: "80px" }}
                ></Column>
                <Column
                  sortable
                  field="filmelier_lastweek_pcconversion"
                  header="Filmelier LW % conversion"
                  style={{ width: "80px" }}
                  body={(rowData) =>
                    formatNumber(rowData.filmelier_lastweek_pcconversion)
                  }
                ></Column>
                <Column
                  sortable
                  field="adrenalinapura_lastweek_streams"
                  header="AP LW Streams"
                  style={{ width: "80px" }}
                  body={(rowData) =>
                    formatNumber(rowData.adrenalinapura_lastweek_streams)
                  }
                ></Column>
                <Column
                  sortable
                  field="adrenalinapura_lastweek_streamedhours"
                  header="AP LW Streamed Hours"
                  style={{ width: "80px" }}
                  body={(rowData) =>
                    formatNumber(rowData.adrenalinapura_lastweek_streamedhours)
                  }
                ></Column>
                <Column
                  sortable
                  field="adrenalinapura_lastweek_uniqueviewers"
                  header="AP LW Unique Viewers"
                  style={{ width: "80px" }}
                  body={(rowData) =>
                    formatNumber(rowData.adrenalinapura_lastweek_uniqueviewers)
                  }
                ></Column>

                
                
                

                
                  {/* <Column
                    sortable
                    field="director_list"
                    header="director_list"
                    style={{ width: "150px" }}
                  ></Column> */}
                
                {/* <Column
                  sortable
                  field="molten_id"
                  header="molten_id"
                  style={{ width: "200px" }}
                ></Column> */}
              </DataTable>
            </>
          ) : (
            <div>
              <ProgressSpinner
                style={{ width: "50px", height: "50px" }}
                strokeWidth="8"
                fill="var(--surface-ground)"
                animationDuration=".5s"
              />
              <img
                src="kamakiri.gif"
                alt="Kamakiri GIF"
                style={{ width: "80px", height: "80px" }}
              />
            </div>
          )}

          <label htmlFor="rows">Rows per page: </label>
          <InputText
            type="text"
            value={pageSize}
            onChange={(e) => setPageSize(e.target.value)}
            style={{ width: "40px" }}
          />
          <Dialog
            visible={platformDialog}
            style={{ width: "450px" }}
            header="Platform Details"
            modal
            className="p-fluid"
            onHide={hideDialog}
          >
            <div className="field">
              <label htmlFor="name">Name</label>
              <InputText
                id="name"
                value={platform.name}
                onChange={(e) => null}
                required
                autoFocus
              />
            </div>
            <div className="field">
              <label htmlFor="description">Description</label>
              <InputTextarea
                id="description"
                value={platform.description}
                required
                rows={3}
                cols={20}
              />
            </div>
          </Dialog>
          <br />
          <br />
          <Button
            label="Export to CSV"
            icon="pi pi-file-o"
            onClick={() => exportExcel()}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchTitles;
